import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Hazem Profile', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my portfolio website Feel free to contact me', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hello There I am',
  name: 'Hazem Sobhy',
  subtitle:
    "I'm a full stack Developer working with Node, React, Next, Python, MongoDB, React Native, Flutter, and more",
  cta: 'Hi Five',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne:
    'I am a Full Stack Js Developer With React JS Advanced Knowledge , Node Js For Web Server Mainly Express , SQL Database And unstructured DB Like Mongo DB',
  paragraphTwo: 'Also Advanced Knowledge with Python For Web Server And Build a Scraping Tools',
  paragraphThree:
    'What Makes you want to hire single developer \n the answer is easy you can get a Secured Web Apps or mobile apps With All Solution in one place \n which will help you control your cost and Deliver What you wish for \n with all customization the app required \n 😎 full controls cost, time, quality 😎',
  // resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'b1.jpg',
    title: 'Static Progressive Web App',
    info:
      'Get Full PWA With a Static Content in Short Time Like A Portfolio, or Bushiness Card For your Business \n If you want To Make A static Store For Your Shop \n Even if You Want To Make A website for Your Social Activity Like A Business Page On Face Book .... and much more',
    info2:
      'Get Your Web Site With Jam stack, with no DB Just a static content and choose Your Domain\n connect Your Social Platform and Go For It\n here an Example for a Current Site For A local Football activity',
    url: 'https://bayernacademy.cf/',
    // repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'b2.jpg',
    title: '3d party Api',
    info:
      'I am Able to work with 3d Party Api and Here an Example App use MabBox Api And earthquake Api',
    info2:
      'This app help Keep you up to date on earthquake detected you need to add your coordinate and see all the red-to-yellow circle  based on power and on click you get more information about the prediction',
    url: 'https://nifty-archimedes-1b0478.netlify.app/',
    repo: 'https://github.com/hazem-a1/mab-box-simple', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'Full Stack app',
    info: 'mobile development with react native ',
    info2: 'full stack with the backend, design, and landing check my google play apps',
    url: 'https://play.google.com/store/apps/dev?id=5129268172062420673',
    // repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'blog.png',
    title: 'My Personal Blog',
    info: 'personal blog with posts and full SEO customization ',
    info2: 'made with netfily stack with content management system ',
    url: 'https://hazem-dev-blog.netlify.app/',
    // repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'Would you like to contact me ?',
  btn: 'Say hi',
  email: 'Hazem.m.sobhy@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://linkedin.com/in/hazem-sobhy-78b270142',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/hazem-a1',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
